<section class="line-item-modal-container">
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
            <div class="text-small">The user can do extensive search using description</div>
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <div class="user-profile__form">
                <section>
                    <form class="row g-3">
                        <div class="col-md-4">
                            <label for="line_item_number" class="form-label text-small">Line Item Number</label>
                            <input type="text" class="form-control form-control" id="line_item_number" readonly [value]="lineItemMarketResult.LINE_ITEM_NUMBER">
                        </div>
                        <div class="col-md-4">
                            <label for="description" class="form-label text-small">Item Description</label>
                            <input type="text" class="form-control form-control" id="description" [(ngModel)] = "lineItemDescription" 
                            (keyup.enter)="fetchMarketResults()">
                        </div>
                        <div class="col-md-4">
                            <div class="m-4">
                                <button type="button" class="btn btn-primary m-2 text-white" (click)="fetchMarketResults()" 
                                    [disabled]="!lineItemDescription">
                                    Search
                                </button>
                            </div>
                        </div>
                    </form>
                    <div class="my-4" *ngIf="marketResults?.length">
                        <div class="table-responsive">
                            <ng-container *ngTemplateOutlet="showMaterialCodeResults ? MaterialCodeTable: ResultTable">
                            </ng-container>
                        </div>
                        <div class="my-3 me-3 text-end">
                            <button class="btn btn-primary text-white" (click)="updateMarketResults()">Update</button>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</section>

<ng-template #MaterialCodeTable>
    <table class="table">
        <thead>
            <tr>
                <th scope="col">#</th>

                <th scope="col">Vendor Number</th>
                <th scope="col">Company Code</th>
                <th scope="col">Cost Center</th>
                <th scope="col">Material</th>
                <th scope="col">Material Description</th>
                <th scope="col">Material Type</th>
                <th scope="col">Purchasing Organization</th>
                <th scope="col">Purchasing Group</th>
                <th scope="col">Purchasing Document</th>
                <th scope="col">Profit Center</th>
                <th scope="col">WBS Element</th>

                <th scope="col" width="180">Action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let result of marketResults; let i = index">
                <th scope="row"> {{i+1}}. </th>
                <td>{{result.VENDOR}}</td>
                <td>{{result.COMPANY_CODE}}</td>
                <td>{{result.COST_CENTER}}</td>
                <td>{{result.MATERIAL}}</td>
                <td>{{result.MATERIAL_DESC}}</td>
                <td>{{result.MATERIAL_TYPE}}</td>
                <td>{{result.PURCHASING_ORGANIZATION}}</td>
                <td>{{result.PURCHASING_GROUP}}</td>
                <td>{{result.PURCHASING_DOCUMENT}}</td>
                <td>{{result.PROFIT_CENTER}}</td>
                <td>{{result.WBS_ELEMENT}}</td>
                <td>
                    <a class="btn btn-outline-primary" (click)="reSearchMarketResult(result.MATERIAL)">
                        Use this
                    </a>
                </td>
            </tr>
        </tbody>
    </table>
</ng-template>

<ng-template #ResultTable>
    <table class="table">
        <thead>
            <tr>
                <th scope="col">#</th>

                <th scope="col">Vendor #</th>
                <th scope="col">Vendor name</th>
                <th scope="col">Mail Address</th>

                <th scope="col">Purchase Order Currency</th>
                <th scope="col">Purchasing Organization </th>
                <th scope="col">Terms of Payment Key</th>
                <th scope="col">First Telephone No</th>

                <th scope="col">First Fax No</th>
                <th scope="col">Building Number</th>
                <th scope="col">City</th>
                <th scope="col">City Postal Code</th>
                <th scope="col">Address Time Zone</th>
                <th scope="col" width="180">Action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let result of marketResults; let i = index">
                <th scope="row"> {{i+1}}. </th>
                <td>{{result.VENDOR_CODE}}</td>
                <td>{{result.VENDOR_NAME}}</td>
                <td>{{result.EMAIL_ADDRESS || "-"}}</td>

                <td>{{result.PURCHASE_ORDER_CURRENCY}}</td>
                <td>{{result.PURCHASING_ORGANIZATION}}</td>
                <td>{{result.TERMS_OF_PAYMENT_KEY}}</td>
                <td>{{result.FIRST_TELEPHONE_NO}}</td>
                <td>{{result.FIRST_FAX_NO}}</td>
                <td>{{result.BUILDING_NUMBER}}</td>
                <td>{{result.CITY}}</td>
                <td>{{result.CITY_POSTAL_CODE}}</td>
                <td>{{result.ADDRESS_TIME_ZONE}}</td>
                <td>
                    <a class="btn btn-outline-primary" *ngIf="!selectedMarketResult[result.ID]" (click)="toggleSelection(result.ID)">Select</a>
                    <a class="btn btn-primary text-white" *ngIf="selectedMarketResult[result.ID]" (click)="toggleSelection(result.ID)">Selected</a>
                </td>
            </tr>
        </tbody>
    </table>
</ng-template>